module.exports = __webpack_public_path__ + "img/85.5b8347ff.jpg";